import React from "react";
import styled, { keyframes } from "styled-components";
import { theme } from "../theme";

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

const ToastWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: ${theme.colors.surface};
  border-radius: ${theme.radius.md}px;
  box-shadow: ${theme.shadows.md};
  margin-bottom: 8px;
  min-width: 280px;
  max-width: 400px;
  animation: ${(props) => (props.$removing ? slideOut : slideIn)} 0.3s ease;
  border-left: 4px solid
    ${(props) => {
      switch (props.$type) {
        case "success":
          return theme.colors.success;
        case "error":
          return theme.colors.danger;
        default:
          return theme.colors.accent;
      }
    }};
`;

const Message = styled.span`
  flex: 1;
  font-size: 14px;
  color: ${theme.colors.text};
  font-family: ${theme.fonts.body};
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${theme.colors.textSecondary};
  font-size: 16px;
  padding: 0;
  line-height: 1;

  &:hover {
    color: ${theme.colors.text};
  }
`;

const Toast = ({ message, type, onClose }) => {
  return (
    <ToastWrapper $type={type} onClick={onClose}>
      <Message>{message}</Message>
      <CloseButton onClick={onClose}>×</CloseButton>
    </ToastWrapper>
  );
};

export default Toast;
